import * as React from 'react';
import { Redirect } from 'react-router-dom';
import { AppPath } from '@app/routes';
export var RootPage = function () {
    return (React.createElement(React.Fragment, null,
        React.createElement(Redirect, { to: AppPath.Map })));
};
